import { GridCellParams } from '@material-ui/data-grid'
import { GridActions } from '../../../components'
import { RowBody } from '../../../components/grid/CustomGrid/types';

type Params = {
	onEdit: (x: GridCellParams) => void,
	onDelete: (x: GridCellParams) => void,
	rows: any
}


export function GetDataBody({ rows,
	onEdit,
	onDelete
}: Params) {
	let dataBody: RowBody[] = [];

	const getAccions = (row: any) => {

		return (
			<>
				<GridActions
					params={{ row }}
					handleEdit={onEdit}
					handleDelete={onDelete}
				/>
			</>
		);
	}


	function GetRow(row: any): any[] {
		return [
			{
				cells: [
					{ key: 'name', field: row.name, tableCellProps: { component: "th", scope: "row", className: "stickySaeta" } },
					{ key: 'description', field: row.description },
					{ key: 'actions', field: getAccions(row) }
				],
				tableRowProps: {
					hover: true
				}
			}
		]
	}

	rows.map((row: any) => {
		row.id && GetRow(row).map((data: any) => dataBody.push(data));
	});
	return dataBody;
}

export const getDataHead = () => {
	let dataHeadTag = sessionStorage.getItem('dataHeadSubCategorias');
	if (dataHeadTag) {
		return JSON.parse(dataHeadTag)
	}
	return dataHead();
}

export const dataHead = () => [
	{ key: 'name', field: "Nombre", tableCellProps: { align: "center", width: 40, className: "separador stickySaeta" } },
	{ key: 'description', field: "Descripción", tableCellProps: { align: "center", width: 250, className: "separador" } },
	{ key: 'actions', field: "Acciones", tableCellProps: { align: "center" } }
];

export const headerExport: any[] = [
	{ key: 'name', label: 'Nombre' },
	{ key: 'description', label: 'Descripción' },
];

export function getDataExport(rows: any[]) {
	let dataBody: any[] = [];

	rows.map((row: any) => (
		dataBody.push(
		{
			name: row.name,
			description: row.description
		}))
	);
	return dataBody;
}